import { render, staticRenderFns } from "./V_Ongoing_PolygonMap_Riddle.vue?vue&type=template&id=718a37aa&scoped=true&"
import script from "./V_Ongoing_PolygonMap_Riddle.vue?vue&type=script&lang=js&"
export * from "./V_Ongoing_PolygonMap_Riddle.vue?vue&type=script&lang=js&"
import style0 from "./V_Ongoing_PolygonMap_Riddle.vue?vue&type=style&index=0&id=718a37aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718a37aa",
  null
  
)

export default component.exports